import { Text } from '@reveni-io/reveni-ui'

import useCreatePreview from './useCreatePreview/useCreatePreview'
import * as Styles from './styles'

const WidgetPreview = ({
  backgroundColor,
  textColor,
  customTextTooBig,
  customTextTooSmall,
  loadScriptContainerId,
  widgetContainerId,
  title,
  sizingRecommendation,
  language,
}) => {
  useCreatePreview({
    backgroundColor,
    textColor,
    customTextTooBig,
    customTextTooSmall,
    loadScriptContainerId,
    widgetContainerId,
    language,
    sizingRecommendation,
  })

  return (
    <Styles.PreviewContainer>
      <Text type="bodyMBold">{title}</Text>
      <Styles.Preview>
        <div id={loadScriptContainerId}></div>
      </Styles.Preview>
    </Styles.PreviewContainer>
  )
}

export default WidgetPreview
